import { Tool } from './base';

export class CrowdStrikeLogScaleTool extends Tool {
  public readonly toolName = 'CrowdStrike LogScale';

  public generateSearchPermalink(
    rootURL: string,
    renderedContent: string,
  ): string {
    const encodedRenderedContent = encodeURIComponent(renderedContent);
    return `${rootURL}/search?live=false&query=${encodedRenderedContent}&start=1d`;
  }
}
